import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import { SMARTGIFT } from '@estee/elc-service-view-names';
import serviceNames, { SmartgiftService } from '~setup/SmartgiftService';

import './exported/smartgift/index';

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

SmartgiftService.setViews(name, getModuleFederatedName(name), version, [SMARTGIFT]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.smartgiftService
});
